import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseTransform',
  standalone: false,
})
export class CaseTransformPipe implements PipeTransform {
  constructor(readonly titleCasePipe: TitleCasePipe) {}

  transform(text: any): string {
    const lastPart = text.includes('.') ? text.split('.').pop() : text;

    // Step 2: Convert camelCase and snake_case to a space-separated string
    const formattedText = lastPart
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // For camelCase
      .replace(/_/g, ' '); // For snake_case

    // Step 3: Use TitleCasePipe to transform the string into title case
    const titleCaseText = this.titleCasePipe.transform(formattedText);

    return titleCaseText;
  }
}
